import ApiService from "@/core/services/api.service";
import apiService from "@/core/services/api.service";
import { SET_ERROR } from "@/core/services/store/auth.module";
import { STATUS_CODE } from "@/core/config/constant";
import { getCsrfRandom } from "@/core/services/store/auth.module";

// mutation types
export const LIST_FORM_BASE = "listFormBase";
export const SET_LIST_FORM_BASE = "setListFormBase";
export const SET_SUCCESS = "SetSuccess";
export const GET_LIST_FORM_BASE = "getListFormBase";
const { SUCCESS, BAD_REQUEST } = STATUS_CODE;
export const SET_STATUS = "SetStatus"
export const SET_ERROR_MESSAGE = "SetErrorMessage"
export const CHECK_URL_FORM = "checkUrlForm"
export const SET_CHECK_URL_FORM = "setCheckUrlForm"
export const GET_FORM_CHILD = "getFormChild"
export const GET_FORM_CHILD_BY_DATE = "getFormChildByDate"
export const DELETE_FILE = "deleteFile"
export const UPLOAD_CHUNKS = "uploadChunks"
const CHUNK_SIZE = 1024 * 1024 * 10; // 10MB
const CHUNK_SIZE_LIMITED = 1024 * 1024 * 1024 * 10; // 10GB

const state = {
    errors: null,
    success: null,
    listFormBase: [],
    status: '',
    error: '',
    checkForm: false,
    message: null,
    uploadChunksProgress: 0,
};

const getters = {
    getListForm: state => state.listFormBase,
    getCheckForm: state => state.checkForm,
    getStatus: state => state.status,
    getMessage: state => state.message,
    getUploadChunksProgress: state => state.uploadChunksProgress,
};


const mutations = {
    [SET_LIST_FORM_BASE](state, listFormBase) {
        state.listFormBase = listFormBase;
    },
    [SET_SUCCESS](state, code) {
        state.success = code;
    },
    [SET_STATUS](state, status) {
        state.status = status
    },
    [SET_CHECK_URL_FORM](state, checkForm) {
        state.checkForm = checkForm
    }
    ,
    [SET_ERROR_MESSAGE](state, message) {
        state.message = message
    }

};

const actions = {
    async  [LIST_FORM_BASE](context, form) {
        if (form.token) {
            ApiService.setHeader(form.token)
        }
        let url_api;
        if (form.formUrlChild) {
            url_api = `user/form-base/get-form-child/${form.code}/${form.answerId}/${form.formUrlChild}`
        } else {
            url_api = `user/form-base/get-form/${form.code}`
        }
        try {
            const response = await ApiService.get(url_api)
            if (response&&response.data.code == SUCCESS) {
                context.commit(SET_LIST_FORM_BASE, response.data.data);
                context.commit(SET_STATUS, response.data.code)
            }
            else if (response&&response.data.code == BAD_REQUEST) {
                context.commit(SET_STATUS, response.data.code)
                context.commit(SET_ERROR_MESSAGE, response.data.message)
            } else if (response&&response.data.code == 404) {
                context.commit(SET_STATUS, response.data.code)
                context.commit(SET_ERROR_MESSAGE, response.data.data)
            }
        } catch (e) {
                throw e;

        }
    },
    async  [CHECK_URL_FORM](context, form) {

        try {
            const response = await ApiService.get(`user/form-base/check-form-1/${form.tenant}/${form.code}`)
            if (response.data.code == SUCCESS) {
                context.commit(SET_CHECK_URL_FORM, true);
                context.commit(SET_STATUS, response.data.code)
            }
            if (response.data.code == BAD_REQUEST) {
                context.commit(SET_STATUS, response.data.code)
                context.commit(SET_ERROR_MESSAGE, response.data.message)
            }
        } catch (e) {
            if (e.response.data.code == ERROR_SERVER) {
                context.commit(SET_ERROR, e.response.data.message);
                throw e.response.data.message
            } else {
                throw e;
            }
        }
    },
    async [GET_FORM_CHILD_BY_DATE](context, form) {
        context.commit(SET_LIST_FORM_BASE, []);
        if (form.token) {
            ApiService.setHeader(form.token)
        }
        let url_api;
        if (form) {
            url_api = `user/form-base/get-form-child-by-date/${form.code}/${form.answerId}/${form.formUrlChild}?date=${form.date}`
        } else {
            url_api = `user/form-base/get-form-child-by-date/${form.code}/${form.answerId}/${form.formUrlChild}`
        }
        try {
            const response = await ApiService.get(url_api)
            if (response.data.code == SUCCESS) {
                context.commit(SET_LIST_FORM_BASE, response.data.data);
                context.commit(SET_STATUS, response.data.code)
            }
            else if (response.data.code == BAD_REQUEST) {
                context.commit(SET_STATUS, response.data.code)
                context.commit(SET_ERROR_MESSAGE, response.data.message)
            } else if (response.data.code == 404) {
                context.commit(SET_STATUS, response.data.code)
                context.commit(SET_ERROR_MESSAGE, response.data.data)
            }
        } catch (e) {
            if (e.response.data.code == ERROR_SERVER) {
                context.commit(SET_STATUS, response.data.code)
                context.commit(SET_ERROR_MESSAGE, e.response.data.message);
                throw e.response.data.message
            } else {
                throw e;
            }
        }
    },
    async [DELETE_FILE](context, payload) {
        try {
            const response = await ApiService.post(`user/form-base/delete-file/${payload.answerIdChild}/${payload.answerValueId}`)
            if (response.data.code == SUCCESS) {
                context.commit(SET_STATUS, response.data.code)
            }
            else if (response.data.code == BAD_REQUEST) {
                context.commit(SET_STATUS, response.data.code)
                context.commit(SET_ERROR_MESSAGE, response.data.message)
            } else if (response.data.code == 404) {
                context.commit(SET_STATUS, response.data.code)
                context.commit(SET_ERROR_MESSAGE, response.data.data)
            }
        } catch (e) {
            if (e.response.data.code == ERROR_SERVER) {
                context.commit(SET_STATUS, response.data.code)
                context.commit(SET_ERROR_MESSAGE, e.response.data.message);
                throw e.response.data.message
            } else {
                throw e;
            }
        }
    },
    async [UPLOAD_CHUNKS](context, payload){
        const csrf_token = getCsrfRandom();
        const totalChunks = Math.ceil(payload.file.size / CHUNK_SIZE);
        if( payload.file.size > CHUNK_SIZE_LIMITED ){
            throw new Error('容量は１０GB以内で入力してください。');
        }

        const uploadChunkInitRes = await ApiService.post(`user/initiate-upload`, {
            file_name : payload.file.name, 
            total_part: totalChunks,
            type_upload: payload.type_upload,
            answer_id : payload.answer_id,
            form_child_url : payload.form_child_url,
            _csrf: csrf_token
        })

        if (uploadChunkInitRes.data.code !== 200) {
            throw new Error(uploadChunkInitRes.data.data[Object.keys(uploadChunkInitRes.data.data)[0]][0]);
        }
        context.state.uploadChunksProgress = totalChunks>2 ? 1 : 50;
        
        // Chunk to upload
        for (let i = 0; i < totalChunks; i++) {
            const start = i * CHUNK_SIZE;
            const end = Math.min(start + CHUNK_SIZE, payload.file.size);
            const chunk = payload.file.slice(start, end);
            const formData = new FormData();
            formData.append("file_path", chunk)
            formData.append("part_number", i+1)
            formData.append("total_part", totalChunks)
            formData.append("file_name", payload.file.name)
            formData.append("upload_id", uploadChunkInitRes.data.data.upload_id)
            formData.append("type_upload", payload.type_upload)
            formData.append("answer_id", payload.answer_id)
            formData.append("form_child_url", payload.form_child_url)
            formData.append("_csrf", csrf_token)
            
            const uploadChunkRes = await apiService.post("user/upload-chunk", formData);
            if (uploadChunkRes.data.code !== 200) {
                const firstKey = Object.keys(uploadChunkRes.data.data)[0]
                throw new Error(uploadChunkRes.data.data[firstKey][0]);
            }

            context.state.uploadChunksProgress = Math.round(((i + 1) / totalChunks) * 100);
        }

        const formData = new FormData();
        formData.append("file_name", payload.file.name);
        formData.append("total_part", totalChunks);
        formData.append("upload_id", uploadChunkInitRes.data.data.upload_id)
        formData.append("type_upload", payload.type_upload)
        formData.append("answer_id", payload.answer_id)
        formData.append("form_child_url", payload.form_child_url)
        formData.append("_csrf", csrf_token)

        // Merge after all chunks uploaded
        const uploadChunkComplateRes = await apiService.post("user/complete-upload", formData)
        if (uploadChunkComplateRes.data.code !== 200) {
            console.error(`=== got error on upload MERGE`, { uploadChunkComplateRes, payload })
            return { data: { file_name: null } }
        }
        context.state.uploadChunksProgress = 0;
        return { ...uploadChunkComplateRes.data, total_chunks: totalChunks, type_upload: payload.type_upload }
    }
}



export default {
    state,
    actions,
    mutations,
    getters
};
